export const classes = {
  wrapper:
    'flex items-center gap-2 rounded-lg px-2 py-1 cursor-pointer hover:bg-black/5',
  label: 'select-none leading-tight',
  name: 'text-sm font-semibold text-taupe-3',
  account: 'text-xs text-taupe-2 hover:underline',
  menuItem: 'py-1 mx-2',
  header: 'flex items-center gap-3 px-4 pb-3 pt-2',
  headerAvatar: 'cursor-default',
  headerInfo: 'min-w-0 leading-tight',
  headerName: 'text-sm font-semibold text-taupe-3',
  headerEmail: 'truncate text-xs text-taupe-2',
  sectionLabel:
    'px-4 pb-1 pt-2 text-[0.65rem] font-semibold uppercase tracking-wide text-taupe-1',
};
